export default "__VITE_ASSET__B0P$7PlP__"